module.exports = __webpack_public_path__ + "img/img-fastspin.63f558d4.png";